/* eslint-disable react/no-array-index-key */
import clsx from 'clsx';
import React from 'react';
import styles from './Autumn.module.scss';
export const Autumn = () => (<>
    {[...new Array(25)].map((_, idx) => (<span key={`${idx}-leaf`} className={clsx(styles.autumnItem, styles[`leaf${Math.floor(Math.random() * 6) + 1}`])}/>))}
  </>);
